"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    className: "symbol-text-underline",
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "16",
    viewBox: "0 0 12 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 16v-2h12v2H0zm6-3.75c-2.8 0-5-2.24-5-5.21V1.09C1 .49 1.4 0 2 0s1 .49 1 1.09v5.95c0 1.5 1.21 3.03 3 3.03s3-1.53 3-3.03V1.09C9 .49 9.4 0 10 0s1 .49 1 1.09v5.95c0 2.97-2.2 5.21-5 5.21z"
  }));
};